import axios from 'axios'

// import store from '@/store'
// import { getToken } from '@/utils/auth'
import router from '../router'

import { baseurl } from "@/config/config"
import { ElMessage } from 'element-plus'
import { getToken,removeToken } from "@/utils/index";


// create an axios instance
const service = axios.create({

    baseURL: baseurl,
    //withCredentials: true, // send cookies when cross-domain requests
    timeout: 100000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {

        //console.log('请求中...')
        // do something before request is sent
        // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改


        let user = {'token':getToken()}
        if (user.token) {
            config.headers['Admin-Token'] = user.token
        } else {
            config.headers['Admin-Token'] = ""
        }

        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
   
        if (response.data.code == -999) {


            //清除token 重要
            removeToken()
            router.push({
                path: '/login',
                query: {}
            })  
        } else {

            return response
        }

    },
    error => {
        console.log('err' + error) // for debug
        ElMessage(error.message)
        return Promise.reject(error)
    }
)

export default service
